import React from 'react';
import OrderInspectionForm from '../../../../_common/components/OrderInspectionForm';
import Grid from "../../../../_common/components/GridTasksNotes";
import {useOrderDetailsUIGlobalContext} from '../../OrderDetailsUIGlobalContext';
import {useOrderDetailsUIOrderContext} from "../../OrderDetailsUIOrderContext";

const OrderInspection = ({shumaID, firmShumaID, useContext}) => {
  const {
    formikOrderInspection,
    decisionTreeProps,
    fieldNames
  } = useContext();

  const {values, setFieldValue, handleChange} = formikOrderInspection;
  const {users} = useOrderDetailsUIGlobalContext();
  const {oldInspectionsForms} = useOrderDetailsUIOrderContext();

  return (
    <OrderInspectionForm
      firmShumaID={firmShumaID}
      values={values}
      fieldNames={fieldNames}
      setFieldValue={setFieldValue}
      handleChange={handleChange}
      decisionTreeProps={decisionTreeProps}
      selectProps={{users}}
      disabledFormCondition={Boolean(shumaID)}
      tasksSection={!oldInspectionsForms && <Grid/>}
    />
  );
};

export default OrderInspection;
